import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AccountScopeProvider } from "@/context/AccountScopeContext";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Transactions from "@/pages/Transactions";
import Categories from "@/pages/Categories";
import Forecast from "@/pages/Forecast";
import Settings from "@/pages/Settings";

const TOAST_OFFSET = { bottom: "var(--toast-bottom)" };

const Loader = () => (
  <div className="min-h-dvh flex items-center justify-center bg-background">
    <div className="w-10 h-10 border-2 border-income border-t-transparent rounded-full animate-spin" />
  </div>
);

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();
  // The OAuth redirect can land on any path carrying the token fragment, so
  // intercept it before the route table is consulted.
  if (location.hash?.includes("session_token=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
      <Route path="/categories" element={<Protected><Categories /></Protected>} />
      <Route path="/forecast" element={<Protected><Forecast /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <AccountScopeProvider>
            <AppRouter />
          </AccountScopeProvider>
          {/* Bottom-centre keeps messages in thumb reach and off the header,
              where a full-screen form keeps its close button. */}
          <Toaster
            position="bottom-center"
            offset={TOAST_OFFSET}
            mobileOffset={TOAST_OFFSET}
            richColors
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
